module.exports = __webpack_public_path__ + "img/face-explode.aaef7159.svg";